/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { PraticaAllegatoDTO } from '../model/models';
import { PraticaAllegatoOperatoreCreationForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface DeletePraticaAllegatoOperatoreRequestParams {
    idTipoPratica: string;
    idPratica: string;
    idAllegato: string;
    version: number;
}

export interface DownloadPraticaAllegatoOperatoreRequestParams {
    idTipoPratica: string;
    idPratica: string;
    idAllegato: string;
}

export interface ListPraticaAllegatiOperatoreRequestParams {
    idTipoPratica: string;
    idPratica: string;
}

export interface UploadPraticaAllegatoOperatoreRequestParams {
    idTipoPratica: string;
    idPratica: string;
    version: number;
    payload: PraticaAllegatoOperatoreCreationForm;
    file: Blob;
}


export interface GestioneAllegatiPraticaServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Cancellazione allegato operatore (capability GESTIONE). Solo origine&#x3D;OPERATORE; CITTADINO/SISTEMA → 422. Gate G1+G2+R2 + cross-tipo R1 applicato dal service. Response codes: 204, 403, 404, 409, 422.
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/allegati/{idAllegato}
* @param requestParameters
     */
    deletePraticaAllegatoOperatore(requestParameters: DeletePraticaAllegatoOperatoreRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Download del binario di un allegato (capability CONSULTAZIONE). R1 cross-tipo applicato dal service.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/allegati/{idAllegato}
* @param requestParameters
     */
    downloadPraticaAllegatoOperatore(requestParameters: DownloadPraticaAllegatoOperatoreRequestParams, extraHttpRequestParams?: any): Observable<Blob>;

    /**
     * Lista degli allegati della pratica (capability CONSULTAZIONE). R1 cross-tipo applicato dal service. Niente gate G1/G2 (read endpoint).
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/allegati
* @param requestParameters
     */
    listPraticaAllegatiOperatore(requestParameters: ListPraticaAllegatiOperatoreRequestParams, extraHttpRequestParams?: any): Observable<Array<PraticaAllegatoDTO>>;

    /**
     * Upload di un allegato operatore (multipart). Capability OP_PRATICA + GESTIONE. Gate G1+G2+R2 + cross-tipo R1 applicato dal service. Response codes: 201, 403, 404, 409, 422.
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/allegati-operatore
* @param requestParameters
     */
    uploadPraticaAllegatoOperatore(requestParameters: UploadPraticaAllegatoOperatoreRequestParams, extraHttpRequestParams?: any): Observable<PraticaAllegatoDTO>;

}
